import { Tchekb } from './../model/tchekb.model';
import { Damage, DamagesGroupedByLocation, DamageControlInterface } from './../model/damage.model';
import { Injectable } from '@angular/core';

@Injectable()
export class FastTrackService {

  list: {
    tchekId: string,
    tchek: Tchekb,
    index: number,
    numberDamages: number
    damages: DamageControlInterface[],
    damagesGroup: DamagesGroupedByLocation[],
  }[] = []
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/service/fast-track.service.ts